module.exports = __webpack_public_path__ + "assets/img/loader.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loader.gif
// module id = 1962
// module chunks = 0